import classNames from 'classnames';
import React, { Suspense } from 'react';
import isNil from '../../core/helpers/is-nil';
import { ICON_TYPE_COMPONENT_MAP, IconVariant } from './icon-data';
import styles from './icon.module.scss';

type Size = '12' | '14' | '16' | '24' | '32' | '48' | '56' | '64' | '128';

type Props = {
  className?: string;
  variant: IconVariant;
  size: Size;
  sizeS?: Size;
};

export const Icon: React.FC<Props> = ({ className, variant, size, sizeS }) => {
  const Icon = ICON_TYPE_COMPONENT_MAP[variant];
  const smallClassname = isNil(sizeS) ? '' : styles[`sizeS${sizeS}`];

  return (
    <Suspense
      fallback={<div className={classNames(styles.loader, styles[`size${size}`], smallClassname, className)} />}
    >
      <Icon className={classNames(styles.root, styles[`size${size}`], smallClassname, className)} />
    </Suspense>
  );
};
